import type { AuthEvent, AuthEventCallback } from 'src/services/OAuth2Service';
import { container } from 'src/StaticContainer';

const log = container.get('Logger').getSubLogger({ name: 'AuthEventBus' }, { component: 'auth' });

export class AuthEventBus {
    #subscribers = new Map<string, AuthEventCallback>();
    #nextId = 0;

    subscribe(callback: AuthEventCallback): () => void {
        const id = String(this.#nextId++);
        this.#subscribers.set(id, callback);

        return () => {
            this.#subscribers.delete(id);
        };
    }

    emit(event: AuthEvent): void {
        for (const callback of this.#subscribers.values()) {
            try {
                callback(event);
            } catch (err) {
                log.error('Error in auth event callback', { err });
            }
        }
    }

    clear(): void {
        this.#subscribers.clear();
    }
}
